module.exports = __webpack_public_path__ + "static/qr-code-open-account-pf-modal-30312604ddcae86831848d47f0235f65.png";